<template>
  <div class="mr-1">
    <b-button
      v-if="!isLoadingFile"
      variant="primary"
      class="w-100"
      @click="downloadTemplate"
    >
      <a
        class="text-nowrap text-white"
      > Download Template </a>
    </b-button>
    <b-button
      v-if="isLoadingFile"
      variant="primary"
      class="w-100"
    >
      <b-spinner
        small
        type="grow"
      />
      <a class="text-nowrap text-white">
        Loading...
      </a>
    </b-button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      isLoadingFile: false,
    }
  },

  methods: {
    downloadTemplate() {
    // eslint-disable-next-line no-param-reassign
      this.isLoadingFile = true

      axios.get(
        'manufacture-white-lists/template-download',
        {
          responseType: 'blob', // ✅ IMPORTANT
        },
      )
        .then(res => {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'], // application/pdf
          })

          const url = window.URL.createObjectURL(blob)

          // ✅ Open in new tab
          window.open(url, '_blank')

          // Optional: cleanup
          setTimeout(() => {
            window.URL.revokeObjectURL(url)
          }, 1000)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$toasted.show('File not found', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).finally(() => {
        // eslint-disable-next-line no-param-reassign
          this.isLoadingFile = false
        })
    },
  },
}
</script>
